<template>
  <div :id="chartId" :style="style" ref="chartContainer">Echarts</div>
</template>

<script>
import * as echarts from 'echarts';
import { debounce } from 'lodash';

export default {
  name: 'MyEcharts',
  props: {
    chartId: {
      type: String,
      required: true
    },
    height: {
      type: String,
      default: '100%'
    },
    width: {
      type: String,
      default: '100%'
    },
    options: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      myChart: null,
      resizeHandler: null // 防抖后的重绘
    };
  },
  watch: {
    width() {
      if (this.myChart) {
        this.handleResize();
      }
    },
    options() {
      if (this.myChart) {
        this.myChart.setOption(this.options, {
          notMerge: true
        });
      }
    }
  },
  created() {},
  computed: {
    style() {
      return {
        height: this.height,
        width: this.width
      };
    }
  },
  mounted() {
    this.createEchart();
    this.resizeHandler = debounce(this.handleResize, 50); // 防抖处理，延迟 200ms
    window.addEventListener('resize', this.resizeHandler);
  },
  methods: {
    createEchart() {
      this.myChart = echarts.init(this.$refs.chartContainer, 'dark');
      this.myChart.setOption(this.options);
    },
    handleResize() {
      this.myChart.resize({
        animation: {
          duration: 200
        }
      });
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler);
    if (this.myChart) {
      this.myChart.dispose();
    }
  }
};
</script>

<style scoped></style>
